module.exports = __webpack_public_path__ + "img/register-image.686b0be1.png";